import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { TranscriptRequestResult } from '../../api/models/TranscriptRequestResult';
import { Environment } from '../../Environment';
import { RootState } from '../../model/store';
import { transcriptSlice } from '../../model/transcriptSlice';
import { useToken } from '../../util/GetTokenHook';

export type TranscriptHistoryProps = {
  // Outputs
  /** As the name implies */
  isGettingTranscripts: boolean;
  /** As the name implies */
  transcriptRequests: TranscriptRequestResult[];
};

export const transcriptHistoryContainer = (Screen: React.ComponentType<TranscriptHistoryProps>) => () => {
  const transcriptRequests = useSelector((state: RootState) => state.transcript.list);

  const [isGettingTranscripts, setIsGettingTranscripts] = React.useState(false);

  const { api } = Environment.current();
  const dispatch = useDispatch();

  // Custom hooks
  const { token, isGettingToken } = useToken();

  // To prevent updates on unmount
  const isMounted = useRef(true);
  React.useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Get transcript requests
  React.useEffect(() => {
    if (token) {
      (async () => {
        try {
          setIsGettingTranscripts(true);
          // TODO: replace with paged later
          const requests = await api.getTranscriptRequests(token);
          setIsGettingTranscripts(false);
          if (isMounted.current) {
            dispatch(transcriptSlice.actions.receivedList({ list: requests }));
          }
        } catch (e) {
          toast.error(e.message);
          setIsGettingTranscripts(false);
        }
      })();
    }
  }, [token]);

  return (
    <Screen isGettingTranscripts={isGettingTranscripts || isGettingToken} transcriptRequests={transcriptRequests} />
  );
};
